import hero from "../../assets/images/kuluki/hero.webp";
import website from "../../assets/images/kuluki/website.webp";

const kulukiProjectData = {
  id: "3",
  title: "Web Design & Development for Kuluki Fashion Marketing Agency",
  subtitle:
    "A custom-designed, SEO-optimized WordPress website for a Bangalore-based fashion marketing agency, combining bespoke illustrations, strategic CMS architecture, and organic growth implementation.",
  client: "Kuluki Fashion Marketing Agency",
  year: "2026",
  role: "Web Designer · WordPress Developer · SEO Strategist · UI/UX Architect",
  heroImage: hero,
  skills: [
    "WordPress Development",
    "Custom UI/UX Design",
    "Adobe Illustrator",
    "CMS Architecture",
    "Organic SEO",
  ],
  link: "https://kuluki.com/",

  sections: [
    {
      title: "Strategic Website Design, CMS Architecture & Organic SEO",
      body:
        "• Designed a custom, fashion-focused website layout aligned with the agency’s premium brand positioning.\n\n" +
        "• Developed bespoke visual elements and illustrations using **Adobe Illustrator** to strengthen brand identity.\n\n" +
        "• Built the platform on **WordPress** with a scalable and well-structured **CMS**.\n\n" +
        "• Architected the CMS for seamless content management across services, case studies, and blog sections.\n\n" +
        "• Implemented advanced **Organic SEO** strategies including semantic structure, metadata optimization, and clean URL architecture.\n\n" +
        "• Optimized site performance, responsiveness, and technical foundations to support long-term search visibility and growth.",
      image: website,
    },
  ],
};

export default kulukiProjectData;
